import React, { useState, useEffect } from 'react';
import { PixelBox, PixelButton, PixelContainer } from '../ui/PixelComponents';
import { useAuth } from '../../context/AuthContext';

interface RegisterFormProps {
  onComplete: () => void;
}

export const RegisterForm: React.FC<RegisterFormProps> = ({ onComplete }) => {
  const [registrationData, setRegistrationData] = useState<any>(null);
  const { register, isLoading, error } = useAuth();

  const startRegistration = async () => {
    try {
      const data = await register();
      setRegistrationData(data);
    } catch (error) {}
  };

  useEffect(() => {
    startRegistration();
  }, [register, startRegistration]);

  const handleComplete = () => {
    if (registrationData && registrationData.access_token) {
      onComplete();
    }
  };

  if (isLoading || !registrationData) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '50vh',
        }}
      >
        <div
          style={{
            fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
            fontSize: '20px',
          }}
        >
          {error ? error : 'ЗАГРУЗКА...'}
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        width: '90%',
        maxWidth: '420px',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        padding: '20px',
      }}
    >
      {/* Логотип */}
      <div
        style={{
          display: 'flex',
          gap: '15px',
          height: '66px',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        <PixelBox
          backgroundColor='#000000'
          textColor='#FFFFFF'
          borderColor='#000000'
          shadowColor='#808080'
          size='large'
        >
          <div
            style={{
              fontSize: '32px',
              fontWeight: 'bold',
              padding: '8px 16px',
            }}
          >
            Ё
          </div>
        </PixelBox>
      </div>

      {/* Заголовок ANONIMAZER2000 с полосками */}
      <PixelContainer
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          paddingRight: 0,
          paddingLeft: 0,
        }}
      >
        <div style={{ flex: 1, height: '4px', backgroundColor: '#000' }}></div>
        <div
          style={{
            padding: '0 16px',
            fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
            fontSize: '20px',
            letterSpacing: '5%',
          }}
        >
          ANONIMAZER2000
        </div>
        <div style={{ flex: 1, height: '4px', backgroundColor: '#000' }}></div>

        {/* Белый контейнер с данными */}
        <div
          style={{
            backgroundColor: '#FFF',
            border: '3px solid #000',
            padding: '32px',
          }}
        >
          <div style={{ marginBottom: '24px' }}>
            <div
              style={{
                fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
                fontSize: '12px',
                marginBottom: '8px',
                color: '#666',
              }}
            >
              ВОТ ТВОЙ НОМЕР
            </div>
            <div
              style={{
                fontFamily: 'Roboto Mono, sans-serif',
                fontSize: '32px',
                fontWeight: 'bold',
                letterSpacing: '4px',
              }}
            >
              {registrationData.user.userNumber}
            </div>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <div
              style={{
                fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
                fontSize: '12px',
                marginBottom: '8px',
                color: '#666',
              }}
            >
              КОД ДЛЯ ВХОДА
            </div>
            <div
              style={{
                fontFamily: 'Roboto Mono, sans-serif',
                fontSize: '32px',
                fontWeight: 'bold',
                letterSpacing: '4px',
              }}
            >
              {registrationData.user.loginCode}
            </div>
          </div>

          <div style={{ marginBottom: '32px' }}>
            <div
              style={{
                fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
                fontSize: '12px',
                marginBottom: '8px',
                color: '#666',
              }}
            >
              КЛЮЧ ВОССТАНОВЛЕНИЯ
            </div>
            <div
              style={{
                fontFamily: 'Roboto Mono, sans-serif',
                fontSize: '16px',
                lineHeight: '1.8',
                textTransform: 'uppercase',
                letterSpacing: '2px',
                fontWeight: 'bold',
              }}
            >
              {registrationData.user.recoveryKeys.map((word: string, i: number) => (
                <span key={i}>
                  {word.toUpperCase()}
                  {i < registrationData.user.recoveryKeys.length - 1 ? ' • ' : ''}
                </span>
              ))}
            </div>
          </div>

          <div
            style={{
              textAlign: 'center',
              fontSize: '10px',
              fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
              marginBottom: '24px',
              color: '#666',
            }}
          >
            ЗАПИШИ, ЗАБУДЕШЬ - НАЧНЕШЬ ЗАНОВО
          </div>
        </div>
      </PixelContainer>

      {/* Кнопка В ЧАТ! */}
      <div
        style={{
          display: 'flex',
          gap: '15px',
          height: '66px',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        <PixelButton
          backgroundColor='#C0C0C0'
          borderColor='#000000'
          shadowColor='#808080'
          onClick={handleComplete}
          size='large'
          style={{
            height: '54px',
            width: '198px',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
              fontSize: '30px',
              letterSpacing: '5%',
            }}
          >
            В ЧАТ!
          </div>
        </PixelButton>
      </div>
    </div>
  );
};
